import { StakingPool } from '@trustpad/launchpad/dist/staking/types';

import * as React from 'react';

import { BscContractLink } from '~common/UI';

import { getStakingTokens } from '../../utils';

export function StakingTitle({ pool }: { pool: StakingPool }) {
  const [mainToken, secondToken] = getStakingTokens(pool);
  const combinedSymbol = secondToken
    ? `${mainToken.symbol}-${secondToken.symbol} / ${pool.rewardToken.symbol}`
    : `${mainToken.symbol} / ${pool.rewardToken.symbol}`;

  return (
    <div>
      <h2 className="text-2xl font-secondary tracking-wide">
        {pool.deprecated && '⚠️ '}

        {pool.title}

        <BscContractLink address={pool.address} className="ml-3" />
      </h2>

      <div className="text-sm font-secondary text-ignored">
        {combinedSymbol}
      </div>
    </div>
  );
}
